import React from "react";

const TechBadge = ({ tech, onRemove }) => {
  return (
    <span className="flex items-center gap-2 rounded-md bg-greenn text-dark py-2 px-3  text-sm font-medium">
      {tech}
      {/*<button
        onClick={onRemove}
        className="w-4 h-4 flex items-center justify-center bg-black text-greenn rounded-full text-xs"
      >
        ×
      </button>*/}
    </span>
  );
};

export default TechBadge;
